import React, { useEffect } from 'react'
import { useRaportForm } from '../../context/RaportFormContext'
import Options from './stages/Options'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { faSlidersSolid } from '@/lib/fa'
import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
const BUSINESS_TRIP_OPTIONS = [
  {
    label: 'printout.tripReportBeginingAt',
    value: '0',
  },
  {
    label: 'printout.tripReportEndingAt',
    value: '1',
  },
  {
    label: 'printout.tripReportCalculatedAt',
    value: '2',
  },
  {
    label: 'printout.tripReportSettlementDateAt',
    value: '3',
  },
  {
    label: 'printout.tripReportModifiedAt',
    value: '6',
  },
]
const MANAGER_3_REPORT_OPTIONS = [
  {
    label: 'printout.managerReport3Driver',
    value: '0',
  },
  {
    label: 'printout.managerReport3ChargeSumPLN',
    value: '1',
  },
  {
    label: 'printout.managerReport3BpnSumPLN',
    value: '2',
  },
  {
    label: 'printout.managerReport3KilometerSum',
    value: '3',
  },
  {
    label: 'printout.managerReport3UsedDrivingTime',
    value: '4',
  },
  {
    label: 'printout.managerReport3DrivingToWorkRatio',
    value: '5',
  },
  {
    label: 'printout.managerReport3VacationLeave',
    value: '6',
  },
  {
    label: 'printout.managerReport3SickLeave',
    value: '7',
  },
  {
    label: 'printout.managerReport3GrossWages',
    value: '8',
  },
  {
    label: 'printout.managerReport3NetWages',
    value: '9',
  },
  {
    label: 'printout.managerReport3GrossWagesWithTrips',
    value: '10',
  },
  {
    label: 'printout.managerReport3NetWagesWithTrips',
    value: '11',
  },
]

const ManagerReport = () => {
  const { data, setData } = useRaportForm()
  const { t } = useLocalize()

  useEffect(() => {
    setData({
      manager3ReportOption: 0,
      separateFiles: false,
      issuerSignature: false,
      driverSignature: false,
    })
  }, [])

  const businessOptions = Object.values(BUSINESS_TRIP_OPTIONS).map((ct) => ({
    value: ct.value,
    label: t(ct.label),
  }))

  const managerOptions = Object.values(MANAGER_3_REPORT_OPTIONS).map((ct) => ({
    value: ct.value,
    label: t(ct.label),
  }))

  return (
    <div className="tw-flex-1 tw-space-y-4 tw-overflow-auto tw-p-4 tw-pr-8">
      <div className="tw-flex tw-items-start">
        <StageHeader title={t('printout.data')} textSize="sm" icon={faSlidersSolid} />
        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1 sm:tw-min-w-[400px]">
          <FieldsetSelect
            label={t('printout.business-trips')}
            placeholder={t('common.select')}
            value={
              data?.tripReportOption !== undefined
                ? data.tripReportOption.toString()
                : '0'
            }
            name="tripReportOption"
            onChange={(e) => {
              setData({
                ...data,
                tripReportOption: Number(e.target.value),
              })
            }}
            searchEnabled={false}
            options={businessOptions}
          />
          <CheckboxWithLabelField
            field="onlySettled"
            data={data}
            setData={setData}
            label={t('printout.only-settled')}
          />
          <FieldsetSelect
            label={t('printout.sort-by')}
            placeholder={t('common.select')}
            value={
              data?.manager3ReportOption !== undefined
                ? data.manager3ReportOption.toString()
                : '0'
            }
            name="manager3ReportOption"
            onChange={(e) => {
              setData({
                ...data,
                manager3ReportOption: Number(e.target.value),
              })
            }}
            searchEnabled={false}
            options={managerOptions}
          />
        </div>
      </div>
      <DividerHorizontal />
      <Options
        setData={setData}
        data={data}
        vehicleActivity={false}
        separateFilesOnly={false}
      />
    </div>
  )
}

export default ManagerReport
